import { Injectable } from '@angular/core';
import { Meta } from '@angular/platform-browser';

import { OpenGraphConfig } from './../../../shared/models';

@Injectable({
  providedIn: 'root',
})
export class SeoService {
  constructor(private meta: Meta) {}

  public generateTags(config: OpenGraphConfig): void {
    this.setOpenGraphTags(config);
    this.setTwitterTags(config);
  }

  private setOpenGraphTags(config: OpenGraphConfig): void {
    this.meta.updateTag({ property: 'og:type', content: 'article' });
    this.meta.updateTag({
      property: 'og:site_name',
      content: 'SignGaze',
    });
    this.meta.updateTag({ property: 'og:title', content: config.title });
    this.meta.updateTag({
      property: 'og:description',
      content: config.description,
    });
    this.meta.updateTag({ property: 'og:image', content: config.image });
    this.meta.updateTag({
      property: 'og:url',
      content: config.url,
    });
  }

  private setTwitterTags(config: OpenGraphConfig): void {
    this.meta.updateTag({ name: 'twitter:card', content: 'summary' });
    this.meta.updateTag({ name: 'twitter:site', content: 'SignGaze' });
    this.meta.updateTag({ name: 'twitter:title', content: config.title });
    this.meta.updateTag({
      name: 'twitter:description',
      content: config.description,
    });
    this.meta.updateTag({ name: 'twitter:image', content: config.image });
  }
}
